<template>
	<div class='action-handler'>
		<div class="col-sm-12 bg">
			<div class='row h-100'>
				<div class="col-sm-8 offset-sm-2 modaly h-100">
					<DisplayAction v-if='action_type == "Display"' @complete="complete"/>
					<RedirectAction v-if='action_type == "Redirect"' />
					<ChallengeAction v-if='action_type == "Challenge"' @failure="failure" @complete="complete"/>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
	.display-action{
		h2.display-header{
			margin-bottom: 0px;
		}
		hr{
			margin: 20px 0px;
		}
		.display-title{
			font-weight: bold;
			background-color: #EEE;
			padding-top: 5px;
			padding-bottom: 3px;
			margin-bottom: 3px;
		}
		.display-text{
			padding-top: 5px;
		}
		.button-box{

			text-align: center;

			.submit-button{
				float:none;
				margin-top: 20px;
			}
		}
	}
	.action-handler{
		.bg{
			background-color: rgba(20,20,20,0.45);
			top: 0px;
			left: 0px;
			width: 100%;
			height: 100%;
			position: absolute;
			z-index:9999;
			padding: 50px 0px;
			min-height: 560px;

			.modaly{
				min-height: 300px;
				background-color: white;
				padding: 40px;
			}
		}
	}
</style>

<script>

import { mapGetters } from "vuex"

import DisplayAction from "@/components/actions/DisplayAction";
import RedirectAction from "@/components/actions/RedirectAction";
import ChallengeAction from "@/components/actions/ChallengeAction";

export default {
	name: "ActionHandler",
	components: {
		DisplayAction,
		RedirectAction,
		ChallengeAction
	},
	computed: {
		action_type(){
			if(this.action().Display !== undefined) return "Display";
			else if(this.action().Redirect !== undefined) return "Redirect";
			else if(this.action().Challenge !== undefined) return "Challenge";
			else {
				// None of the valid actions were found! Handle the error
				return "Error";
			}
		}
	},
	methods: {
		complete: function(data) {
			 this.$emit('complete',  data);
			 return;
		},
		failure: function(data) {
			 this.$emit('failure',  data)
		},
		...mapGetters(["action"])
	}
}
</script>
